import "./Icon.scss";
import propTypes from "prop-types";

const Icon = ({
  icon,
  color,
  onClick,
  width,
  height,
  position,
  marginLeft,
  marginTop,
  marginRight,
  marginBottom,
  className,
  disabled,
  dataTestId,
}) => {
  return (
    <input
      id="icon"
      className={`button-style btn-icon ${icon} ${color} ${className}
      ${position}`}
      disabled={disabled}
      style={{
        cursor: onClick ? "pointer" : "default",
        width: `${width || 20}px`,
        height: `${height || 20}px`,
        marginLeft: `${marginLeft || 0}px`,
        marginTop: `${marginTop || 0}px`,
        marginRight: `${marginRight || 0}px`,
        marginBottom: `${marginBottom || 0}px`,
      }}
      onClick={onClick}
      data-testid={dataTestId}
    />
  );
};

export default Icon;

Icon.propTypes = {
  icon: propTypes.string,
  color: propTypes.string,
  onClick: propTypes.func,
  width: propTypes.number,
  height: propTypes.number,
  position: propTypes.string,
  marginLeft: propTypes.number,
  marginTop: propTypes.number,
  marginRight: propTypes.number,
  marginBottom: propTypes.number,
  className: propTypes.string,
  disabled: propTypes.bool,
  dataTestId: propTypes.string,
};
